const personal = [
  ['registrationNumber', 'Matrícula'], ['fullName', 'Nome'], ['cpf', 'CPF'], ['classId', 'Turma'],
  ['status', 'Status'], ['gender', 'Gênero'], ['whatsapp', 'Whatsapp'], ['phone', 'Telefone'], ['email', 'E-mail'],
  ['courseId', 'Cursos'], ['enrollmentDate', 'Inscrição'], ['birthDate', 'Data de nascimento'],
  ['exitDate', 'Data de saída'], ['exitReason', 'Motivo de saída'], ['school', 'Escola'], ['educationLevel', 'Escolaridade'],
  ['cras', 'CRAS'], ['familyIncome', 'Renda familiar'],
];
const work = [
  ['mtApprenticeNumber', 'Nº de aprendiz'], ['mtCurrentCompany', 'Empresa atual'], ['mtRole', 'Função'], ['mtCourse', 'Curso MT'],
  ['mtAdmissionDate', 'Admissão'], ['mtStartDate', 'Início na empresa'], ['mtEndDate', 'Fim do contrato'],
  ['mtHoursPerDay', 'Horas/dia'], ['mtWorkload', 'Horário de trabalho'], ['mtCourseTime', 'Horário do curso'],
  // The settings selector identifies the source even when table headings are shorter.
  ['wrEnrollmentDate', 'Inscrição (MT)'], ['wrObservations', 'Observações (MT)'],
  ['wrExitDate', 'Saída (MT)'], ['wrExitReason', 'Motivo de encerramento (MT)'],
];
export const consultationColumnOptions = enabled => [...personal, ...(enabled ? work : [])].map(([key, label]) => ({ key, label }));
const defaultKeys = ['registrationNumber', 'fullName', 'cpf', 'classId', 'status', 'whatsapp', 'courseId', 'enrollmentDate'];
export const resolveConsultationColumnKeys = (configured, enabled, fallbackKeys = defaultKeys, availableKeys) => {
  const allowed = new Set(consultationColumnOptions(enabled).map(column => column.key));
  if (Array.isArray(availableKeys)) {
    const renderable = new Set(availableKeys);
    for (const key of allowed) if (!renderable.has(key)) allowed.delete(key);
  }
  const selected = [...new Set(Array.isArray(configured) ? configured : [])].filter(key => allowed.has(key));
  // Empty and obsolete saved selections must still show identifying data.
  return selected.length ? selected : fallbackKeys.filter(key => allowed.has(key));
};
